import { render, staticRenderFns } from "./PayrollFormTable.vue?vue&type=template&id=1b38d2d4&"
import script from "./PayrollFormTable.vue?vue&type=script&lang=js&"
export * from "./PayrollFormTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports